
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicEventsApi extends BaseModulePublicApi {
  basePath = 'events';
};
